import { authAxios } from '@components/Auth';
import { API_V1_BASE } from '@config';
import { WithParams } from '@utils/typescript';
import { snakes } from '@utils/lodash';

export type UpdateUserMobileNumberParams = WithParams<{
  mobile_number: string;
  otp_code: string;
}>

export class UserMobileNumberApi {
  static update = async (params: UpdateUserMobileNumberParams) => {
    return await authAxios
      .put(`${API_V1_BASE}/user/mobile_number`, snakes(params));
  };
}
